import { defineMessages } from '@/i18n'

/** App-level strings outside any one feature: route loaders and the boot splash. */
export const appMessages = defineMessages({
  en: { loadingMap: 'Loading map' },
  de: { loadingMap: 'Karte wird geladen' },
  cnr: { loadingMap: 'Učitavanje mape' },
  bs: { loadingMap: 'Učitavanje mape' },
  sr: { loadingMap: 'Učitavanje mape' },
})
